import styled from 'styled-components'
import { WithMathFormula } from '@edulastic/common'

const StyledHeader = WithMathFormula(styled.div`
  padding: 6px;
`)

export default StyledHeader
